import React, { FC, useState } from 'react';
import {
    Flex,
    Image,
    View,
    ActionButton,
    ActionGroup,
    Item,
    Text
} from '@adobe/react-spectrum';
import find from 'lodash/find';

import NakerLogo from '~/Assets/image/Carré.png';

import { _engine, _contentsManager } from '~/Services/Studio/studioScene';

const ModelList = [
    {
        name: 'Wastecan',
        url: 'https://d2uret4ukwmuoe.cloudfront.net/nodsmfm861fx0q645lmmn/untitled.glb'
    },
    {
        name: 'Speakers',
        url: 'https://d2uret4ukwmuoe.cloudfront.net/test/speaker.glb'
    }
];

export const CommentHeader: FC = ({ onLoad }) => {
    const [selectedModel, setSelectedModel] = useState(ModelList[0].name);
    const [projectName, setProjectName] = useState('Product E2235674987: wastecan');

    const loadModel = (name) => {
        const mod = find(ModelList, (m) => m.name === name.toString());
        setProjectName(`Product E2235674987: ${mod.name}`);
        setSelectedModel(mod.name);
        _engine.loadModelFromUrl(mod.url, null, () => {
            _contentsManager.listenEvent(true);
        });
        onLoad();
    };

    return (
        <View
            zIndex={10}
            backgroundColor="gray-100"
        >
            <Flex
                height="size-800"
                direction="row"
                width="100%"
                gap="size-200"
                alignItems="center"
            >
                <Flex
                    direction="row"
                    width="size-3400"
                    alignItems="center"
                    gap="size-100"
                    marginStart="size-100"
                >
                    <ActionButton
                        width="size-600"
                        height="size-600"
                        isQuiet
                    >
                        <Image
                            src={NakerLogo}
                            alt="naker-logo"
                            margin={0}
                        />
                    </ActionButton>
                    <Text>{projectName}</Text>
                </Flex>
                <Flex flex />
                <ActionGroup
                    isQuiet
                    buttonLabelBehavior="collapse"
                    selectionMode="single"
                    isEmphasized
                    marginEnd="size-200"
                    disallowEmptySelection
                    selectedKeys={[selectedModel]}
                    onAction={loadModel}
                >
                    {ModelList.map((m) => (
                        <Item key={m.name}>
                            <Text>{m.name}</Text>
                        </Item>
                    ))}
                </ActionGroup>
            </Flex>
        </View>
    );
};
